module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/customize_desktop-4933bb9d3f99ae9d53d2a2df1117b3d2.webp";